// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2oAJx","clinicsSelect":"TableHeading_clinicsSelect__34hTe"};